import { purchaseFormatLabel, type Ingredient, type Supplier } from '@alexiarest/shared';

type IngredientIdentity = Pick<Ingredient, 'name'> & Partial<Ingredient>;
export function ingredientDetails(ingredient: IngredientIdentity, suppliers: Supplier[]): string {
  const format = ingredient.purchaseQty != null && ingredient.purchaseUnit
    ? purchaseFormatLabel(ingredient) : ingredient.presentation;
  return [format, ingredient.brand, suppliers.find(s => s.supplierId === ingredient.supplierId)?.name].filter(Boolean).join(' · ');
}
export function ingredientLabel(ingredient: IngredientIdentity, suppliers: Supplier[]): string {
  return [ingredient.name, ingredientDetails(ingredient, suppliers)].filter(Boolean).join(' · ');
}
